<template lang="pug">
  #companion-main-content
    WtTile.is-flex.is-flex-direction-column.is-align-items-center
      .columns.is-multiline
        .column.is-centered
          .card
            .green-card(:style="{ backgroundColor: backgroundColor }")
              .cover-art
                  img(:src="heroImage", alt="Album cover")
            .card-content
              p.custom-tag.mb-2 {{ tag }}
              WtTitle.pb-0 {{ title }}
              .icon-and-text-container
                WtSvgIcon(icon="icon_time" width="16px" height="16px" style="padding-top: 4px;")
                span {{ duration  }} read
              .article-content.pb-1(v-html="content")  
</template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "CompanionContentCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    id: { type: String, default: "" },
    title: {
      type: String,
      default: "Let's talk about the menopause  and talk to our employers too. "
    },
    backgroundColor: {
      type: String,
      default: "#a4d8cb"
    },
    heroImage: {
      type: String,
      default:
        "https://s3-alpha-sig.figma.com/img/82d9/0a4b/5d0e10cb28677d1b9cd71d0867d6e058?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=OEjzchtieGrLIJ60~s-S9KZxnlgsGDLVFbU7EdZrCTksqvW--~oV~Vb1BJI60RksleyNQ2QVCteITe3~0mLUYMRR07C~zhAexP1kKXkA2LahOequr4Fku-CYUgvrEtW07KpwhmCulgq0sAtb8AAWpanXkO7tXeI2xkm6Hc1dx30RWBk5BPyJ-Lnu5P-qBy1mOEXLT-BHyCmDxPNMXktKoMx8mY6zacemsHg27Z4WyJrEmzkfX25tpHNR90ufHKptEoXlvdzxVmaVBb597Am21rTPXgXyJTe7n-aUl3CtHMuaLUJv0SzWEfxdcmCv6luGpk9ZtJLVI9NRP~VH~dxqQw__"
    },
    tag: { type: String, default: "" },
    duration: { type: String, default: "" },
    content: {
      type: String,
      default:
        "<p>Switching off from work is essential to maintaining a good work/life balance which helps support our mental wellbeing.</p>\n<p>There are a number of practical changes that you can make to your immediate environment that can help you to switch off.</p>\n<h4>Tip 1 - Consider your workspace</h4>\n<p>Firstly, if you are working from home, consider the space that you work in: is it separate and distinct to the space that you relax in?</p>\n<p>Ideally, where possible, your work should take place in a separate room.</p>\n<p>If this isn't possible, designating a desk space in a specific area of a room for work, and work only, can help maintain boundaries between work and home life.</p>\n<h4>Tip 2 - Add a transitional activity</h4>\n<p>Whether you're working from home or at the office, try introducing a transitional activity to the end of your working day.</p>\n<p>This can help your mind to register the shift between the working day and the time to relax.</p>\n<p>Ordinarily, if you're working at your place of work, this might involve going to the gym on the way home, or simply the act of exiting the workplace and travelling on your commute can be the buffer between the two.</p>\n<p>If you are working from home, getting out of the house briefly at this time of the day can be helpful.</p>\n<p>Wherever you finish your working day, having a real awareness of environmental change or distinct activity will signal the end of the working day and help your mind to switch off and leave 'work mode'.</p>\n<p>Perhaps put some music on, or do some relaxation exercises or physical stretching, where possible in another room.</p>\n<p>This will help create enough of a boundary to support you with 'switching off'.</p>\n<h4>Tip 3 - Take breaks</h4>\n<p>A similar strategy should be applied to any breaks that you take during the day.</p>\n<p>Ideally, try to leave the room that you are working in during the day, and avoid falling into the habit of eating lunch at your desk.</p>\n<p>Where possible, avoid checking work related emails or chat messages when you are not at work.  </p>\n<p>You can put in place boundaries around this by letting colleagues know when you will not be reachable and setting up automatic replies.</p>\n<p>And remember, to maintain a good sense of mental wellbeing and work/life balance, we all need to apply healthy boundaries.</p>"
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
#companion-main-content {
  font-weight: 60 !important;
  font-family: Manrope !important;
  font-style: normal !important;
  line-height: 30px;
  font-size: 1.3rem;

  .title {
    font-family: Manrope !important;
    font-style: normal !important;
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0.18px;
    color: #1b1d20;
    margin-bottom: 0.5rem !important;
  }

  .custom-tag {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #5a5c60;
    font-family: Manrope !important;
    font-style: normal !important;
  }

  .main-card {
    + tablet {
      max-width: 1200px;
      width: auto;
    }
  }

  .green-card {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0px 28px 0px;

    .cover-art {
      height: 220px !important;
    }
    .cover-art img {
      height: 220px;
      object-fit: cover;
    }
  }

  .card-content {
    padding: 0rem 0rem 0rem 0rem !important;

    .article-content {
      /deep/ h4 {
        font-family: Manrope !important;
        font-style: normal !important;
        padding-top: 16px;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0.18px;
      }

      /deep/p.avenir-medium {
        color: #1b1d20;
        font-family: Manrope;
        margin-top: 20px;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.25px;
        padding-top: 0px !important;
      }

      /deep/ p {
        font-family: Manrope !important;
        font-style: normal !important;
        padding-top: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #5a5c60;
      }

      /deep/ ul {
        list-style-type: disc !important;
        padding-left: 20px !important;
        font-family: Manrope !important;
        font-style: normal !important;
        padding-top: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #5a5c60;
      }

      /deep/ li {
        margin-bottom: 8px !important; /* Add space between list items */
      }
    }
  }

  .icon-and-text-container {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #5a5c60;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
}
</style>
